const usePrettyOptions = (options) => options?.map(opt => {
  let label = opt
  let value = opt
  let icon
  if (typeof opt === 'object') {
    label = opt.label
    value = opt.value
    icon = opt.icon
  }
  return { value, label, icon }
})

export default usePrettyOptions;
